import type { TranslationKey } from '../i18n';

/**
 * 密码复杂度策略（与后端 validatePasswordStrength 保持一致）
 *
 * 规则：8-64 位，且同时包含字母和数字。
 * 仅用于设置新密码的场景（注册、修改密码、重置密码）；
 * 登录不做复杂度校验——存量用户的老密码可能不满足新规则。
 */

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;

/**
 * 校验密码复杂度
 *
 * @returns null 表示合规，否则返回 i18n 词条 key
 */
export function validatePasswordStrength(password: string): TranslationKey | null {
  if (password.length < PASSWORD_MIN_LENGTH || password.length > PASSWORD_MAX_LENGTH) {
    return 'auth.pwdErrLength';
  }
  if (!/[A-Za-z]/.test(password) || !/[0-9]/.test(password)) {
    return 'auth.pwdErrChars';
  }
  return null;
}
